import { Pill, useDeviceSize } from "@climate-science/component-library";
import { Trans, useTranslation } from "next-i18next";
import styles from "./BasicHero.module.scss"
// import Dubai from "@cs/public/img/olympiad/CSO23/dubai.png";
import Image, { ImageProps } from "next/image";

const BasicHero = ({background, ns, heading, tags, children, color, footer}:{
  background: ImageProps,
  ns: string
  heading: string
  tags?: string
  children: JSX.Element
  color?: "white" | "blue"
  footer:string
}) => {
  const {t} = useTranslation(ns)
  const {isMobile} = useDeviceSize()

  return (
    <header className={styles.heroContainer}>
      <figure>
        <Image
          layout={ !isMobile ? 'responsive' : 'fixed'}
          {...background}
          alt={background.alt}
        />
      </figure>
      <section className={
        styles[`text${color ? `-${color}` : '' }`]
      }>
        <div>
          {
            !!tags && (
              <div className={styles.pills}>
                {t<string, string[]>(tags, { returnObjects: true }).map((tag, i) => (
                  <Pill className={styles.pill} key={i} color="primary">{tag}</Pill>
                ))}
              </div>
            )
          }

          <h1>
            <Trans
              t={t}
              i18nKey={heading}
            />
          </h1>
          {children}
        </div>
        <footer>
          <p>
            <Trans
              t={t}
              i18nKey={t(footer)}
            />
          </p>
        </footer>
      </section>
    </header>
  );
}

export default BasicHero;